import { EventDetail } from "../../_interfaces/eventDetail";
import { IEventFormatter } from "./ievent-formatter";

export class SkillAssignmentFormatter implements IEventFormatter {

    public format(properties: any, type_id: string): EventDetail[] {
        const formattedMessages: EventDetail[] = [];
        
        // La structure de l'événement est : { added: [{id, name, ...}], removed: [{id, name, ...}] }
        const changes = properties;

        console.log("SkillAssignmentFormatter formatting event:", type_id, properties);

        switch (type_id) {
            case 'Team.skill.edit':
                
                // 1. Gérer les ajouts (Skills ajoutées à l'équipe)
                if (changes.added && changes.added.length > 0) {
                    // Nous allons passer la liste des noms de compétences pour que la traduction
                    // puisse les joindre (join) ou les afficher en liste.
                    const skillNames = changes.added.map((skill: any) => skill.name);
                    
                    formattedMessages.push({
                        key: 'EVENTS.SKILL_EDIT.SKILL_ADDED',
                        params: { 
                            // Traduction : "A ajouté la(les) compétence(s) : {{skillList}}"
                            skillList: skillNames.join(', ')
                        }
                    });
                }

                // 2. Gérer les suppressions (Skills retirées de l'équipe)
                if (changes.removed && changes.removed.length > 0) {
                    const skillNames = changes.removed.map((skill: any) => skill.name);

                    formattedMessages.push({
                        key: 'EVENTS.SKILL_EDIT.SKILL_REMOVED',
                        params: { 
                            // Traduction : "A retiré la(les) compétence(s) : {{skillList}}"
                            skillList: skillNames.join(', ')
                        }
                    });
                }

            break;
            
            default:
                // Gérer les cas non prévus si nécessaire
                formattedMessages.push({
                    key: 'EVENTS.SKILL_EDIT.UNKNOWN_CHANGE',
                    params: { typeId: type_id }
                });
        }
        
        return formattedMessages;
    }
}